import { render } from "./AppSvgFront.vue?vue&type=template&id=4c549659&scoped=true"
import script from "./AppSvgFront.vue?vue&type=script&lang=js"
export * from "./AppSvgFront.vue?vue&type=script&lang=js"

import "./AppSvgFront.vue?vue&type=style&index=0&id=4c549659&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c549659"]])

export default __exports__